
import { Button,List, Tag } from "antd";
import { useNotification } from "features/Notifications/notification-context";
import { useGetNotificationList, useReadNotification } from "features/Notifications/use-cases/get-dashboard";
import { ReadNotificationDTO } from "features/users";
import { NotificationListPaginated } from "features/users/components/users-filter-form";
import { usePaginationParams } from "hooks";
import { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";
import { getRoute } from "routes/utils";
import { getSignalRConnection } from "utils/signalRConnection";

interface Notification {
  id: number;
  entryId:string,
  title: string;
  description: string;
  isRead: boolean;
  createdOn: string;
  status : string ;
}
const NotificationView = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10); // items per page
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [hasMore, setHasMore] = useState(true);
   const navigate = useNavigate() ;
  const {  decrementUnread } = useNotification();
   const { params, updateParams } =
       usePaginationParams<NotificationListPaginated>({
         page: 1,
         size: 10,
         order_by: 'name'       
       });

   const {data:notificationList_ ,refetch:refreshNotificationList} = useGetNotificationList(params, {
      retry: false,
    });
   
     const {mutate: mutateReadNotification } = useReadNotification();
    

 useEffect(() => {
     setLoading(true);
    updateParams({ page });
     setLoading(false);
  }, [page]);

  // 🔹 Append notifications when API response changes
  useEffect(() => {
    if (notificationList_?.rc?.length) {
     
      if (page === 1) {
        //console.log('notificationList_.rc'+JSON.stringify(notificationList_.rc));
        setTotalRecord(notificationList_?.totalRecords);
       
        setNotifications(notificationList_.rc);
      } else {
        setNotifications((prev) => [...prev, ...notificationList_.rc]);
      }

      if (totalRecord < (pageSize*page)) {
        setHasMore(false);
        } else {
        setHasMore(true);
        }

    }
   
  }, [notificationList_]);
 

useEffect(() => {
 
    if (totalRecord < (pageSize*page)) {
        setHasMore(false);
        } else {
        setHasMore(true);
        }
}, [totalRecord]);


 useEffect(() => {
       const connection = getSignalRConnection();
   
       connection.on("ExitGateRequest", () => {          
          refreshNotificationList();
       });
   
       // optional cleanup
       return () => {
         connection.off("ExitGateRequest");
       };
     }, []);

  const loadMore = () => {
    setPage((prev) => prev + 1);
  };

  const handleMarkRead = (id: number,isRead:boolean,entryId:string) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, isRead: true } : n))
    );
      
    if(!isRead){
      const payload: ReadNotificationDTO = { 
        notificationId:id
       };            
             mutateReadNotification(payload);
        decrementUnread();
        
    }
       navigate(getRoute(ROUTES.LOG_ADMIN_DETAIL, entryId));
    
       
  };

return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800">
          Notifications
        </h3>
      </div>

      
      <div className="bg-white rounded-2xl p-6">
       
       
         
            <List
                itemLayout="horizontal"
                dataSource={notifications}
                renderItem={(item) => (
          <List.Item
            style={{
              backgroundColor: item?.isRead ? "#fff" : "#f6f6f6",
              padding: "12px 16px",
              marginBottom: 8,
              borderRadius: 6,
              borderLeft: item.isRead ? "4px solid #fff" : "4px solid #D1712A",
              cursor: "pointer",
            }}
            onClick={() => handleMarkRead(item.id,item.isRead,item.entryId)}
          >
            <List.Item.Meta
              title={
                <span>
                  {item.title}{" "}
                  {!item.isRead && <Tag color="orange">New</Tag>}
                </span>
              }
              description={
                <>
                {item.description}
                <br />
                <Tag color={
                    item.status === "Approved"
                      ? "green"
                      : item.status === "Rejected"
                      ? "red"
                      : "gray"
                  }>
                  {item.status}
                </Tag>
                </>

              }
            />
            
            
            <div style={{ fontSize: 12, color: "#999" }}>
              {item.createdOn}  
            </div>
          </List.Item>
        )}
      /> 

        {!hasMore && (
          <p style={{ textAlign: "center",color: "#999", marginTop: 8 }}>No more notifications</p>
        )}

        {hasMore && (
            <div style={{ textAlign: "center", marginTop: 16 }}>
                    <Button onClick={loadMore} loading={loading}>
                    Load More  
                    </Button>
                </div>
        )}
      
        

        

          
       

      </div>
    </div>
  )
}

export default NotificationView;
